import { useTelephonyContext } from '../../../../../contexts/TelephonyContext';
import TelephonyTopPanel from './TelephonyTopPanel';
import { Box } from '@coolblue-development/freddy';
import EmptyState from '../../Common/EmptyState';

const TelephonyPage = (): JSX.Element => {
  const { selectedRecentCall } = useTelephonyContext();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <TelephonyTopPanel selectedRecentCall={selectedRecentCall} />
      {!selectedRecentCall.phoneNumber && <EmptyState title="No active call" />}
    </Box>
  );
};

export default TelephonyPage;
